import React from 'react';
import { NavLink } from 'react-router-dom';
import CustomForm from 'components/Form/CustomForm';
import useResetPassword from '../../hooks/useResetPassword';
import styles from './ResetPasswordForm.module.scss';

function ResetPasswordForm({ token }: { token: string }) {
  const { fields, formValue, isLoading, model, onChange, onSubmit } =
    useResetPassword(token);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Reset Password</h1>
      <CustomForm
        onChange={onChange}
        onSubmit={onSubmit}
        model={model}
        formValue={formValue}
        isLoading={isLoading}
        fields={fields}
        isDisabled={false}
        submitLabel="Reset Password"
        hasChanges
        submitBtnSize="full"
      />

      <div className={styles.linksContainer}>
        <NavLink className={styles.customLink} to="/">
          <p>Return to login.</p>
        </NavLink>
      </div>
    </div>
  );
}

export default ResetPasswordForm;
